'use client';
import { jsx } from 'react/jsx-runtime';
import { Slot } from '@radix-ui/react-slot';
import { forwardRef, useContext, version } from 'react';
import { Button } from '../button/button.js';
import { Context } from './popover-trigger-context.js';

/**
 * PopoverTrigger component, used to trigger a popover.
 *
 * @example
 * <PopoverTriggerContext>
 *   <PopoverTrigger>Open Popover</PopoverTrigger>
 *   <Popover>
 *     Content
 *   </Popover>
 * </PopoverTriggerContext>
 *
 * @example inline
 * <PopoverTriggerContext>
 *   <Paragraph>
 *    We can use it <PopoverTrigger inline={true}>inline</PopoverTrigger>.
 *   </Paragraph>
 *   <Popover>
 *     Content
 *   </Popover>
 * </PopoverTriggerContext>
 */
const PopoverTrigger = forwardRef(function PopoverTrigger({ id, inline, asChild, popovertarget, popoverTarget, ...rest }, ref) {
    const { popoverId } = useContext(Context);
    const Component = asChild ? Slot : inline ? 'button' : Button;
    const popoverVal = popoverTarget ?? popovertarget ?? popoverId;
    const popoverKey = version.startsWith('19')
        ? 'popoverTarget'
        : 'popovertarget';
    return (jsx(Component, { ref: ref, "data-popover": inline ? 'inline' : undefined, [popoverKey]: popoverVal, ...rest }));
});

export { PopoverTrigger };
